module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/popups/my-stuff/removed-items/removed-properties/removed-properties.component.less
// module id = ./src/app/components/popups/my-stuff/removed-items/removed-properties/removed-properties.component.less
// module chunks = main